//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyPagination from '../../my-pagination.vue'
export default {
    props: [],
    data () {
        return {
            testFileGuid: 'test-file-guid'
        }
    },
    methods: {
        
    },
    mounted: function() {
        
    }
}
